var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isReseller == false)?_c('customers-visual-visitor'):_vm._e(),(_vm.isReseller == true)?_c('customers-reseller'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }